<template>
  <div class="basic__wrap"
  :class="seqDirection"
  :style="{ height: isImageExceedContainer, width: mode === 'only' ? '100%' : '780px' }"
  :seq="pageSeqData"
  >
    <!-- <span class="node-arrow">
      <i class="anima-arrow-1"></i>
    </span> -->
    <ba-page-node-arrow v-if="isPrevArrow"
              :positionX="`-${offsetDistance}px`"
              :positionY="`71px`"
              :width="offsetDistance - 72"
              :height="50"
              :maxOverlap="0"
              :start="25"
              :end="25"
              :weight="25"
              :index="pageSeqData"
              :time="2"
              :active="true"
              :startColor="`#0e90a5`"
              :endColor="'#0e90a5'"
              :disabledStartColor="`#dbdbd8`"
              :disabledEndColor="`#b0c9cd`"
              :disabled="null"
              :shadow="true"
      />
      <ba-page-node-arrow v-if="isNextArrow"
              :positionX="`${780}px`"
              :positionY="`71px`"
              :width="offsetDistance"
              :height="50"
              :maxOverlap="0"
              :start="25"
              :end="25"
              :weight="25"
              :index="pageSeqData"
              :time="2"
              :active="true"
              :startColor="`#0e90a5`"
              :endColor="'#0e90a5'"
              :disabledStartColor="`#dbdbd8`"
              :disabledEndColor="`#b0c9cd`"
              :disabled="null"
              :shadow="true"
      />
    <div class="heatmap__control-side neumor__wrap">
      <div class="convertion-wrap">
        <div class="title">{{ $t('heatmap.segment.labels.conversion') }}</div>
        <div class="contents">
          <BaNeuButton
            v-for="(item, i) in eventSourceButtons" :key="i"
            :icon="`icon--${item.key === 'conversion' ? 'stayInCount' : 'dropOff'}-18`"
            :active="item.type"
            :hide-label="true"
            @click="setEventSource(item.key, i, !item.type)"
            :tooltip="`${$t(item.t)}`"
            />
        </div>
      </div>
      <div class="refresh-wrap">
        <div class="title">{{ $t('heatmap.segment.labels.refresh') }}</div>
        <div class="contents">
          <BaNeuButton
          :active="selectedSegment.reload === true || selectedSegment.reload === 'all'"
          icon="icon--refresh-on-18"
          :hide-label="true"
          @click="onSegmentChange(true, 'reload')"
          :tooltip="$t('heatmap.segment.tooltip.refresh')"
          />
          <BaNeuButton
          :active="selectedSegment.reload === false || selectedSegment.reload === 'all'"
          icon="icon--refresh-off-18"
          :hide-label="true"
          @click="onSegmentChange(false, 'reload')"
          :tooltip="$t('heatmap.segment.tooltip.refreshX')"
          />
        </div>
      </div>
      <div class="rollback-wrap">
        <div class="title">{{ $t('heatmap.segment.labels.rollback') }}</div>
        <div class="contents">
          <BaNeuButton
          :active="selectedSegment.rollback === true || selectedSegment.rollback === 'all'"
          icon="icon--rollback-on-18"
          :hide-label="true"
          @click="onSegmentChange(true, 'rollback')"
          :tooltip="$t('heatmap.segment.tooltip.rollback')" />
          <BaNeuButton
          :active="selectedSegment.rollback === false || selectedSegment.rollback === 'all'"
          icon="icon--rollback-off-18"
          :hide-label="true"
          @click="onSegmentChange(false, 'rollback')"
          :tooltip="$t('heatmap.segment.tooltip.rollbackX')"
          />
        </div>
      </div>
    </div>
    <div v-if="mode !== 'only'" class="segment_area">
      <div class="segment-header-wrapper">
        <div class="segment-header-title">
          <a class="link-btn" :href="pageData.url" target="_blank">
            <i class="icon icon--link"></i>
          </a>
          <div class="title ellipsis">{{ pageData.title }}</div>
        </div>
        <div class="segment-header-url">
          <div class="url ellipsis">{{ pageData.url }}</div>
          <TrackingHistory :heatmap-info="heatmapParams" :aid="aid" :period-date="journeyPeriod" />
        </div>
        <div class="close" @click="setHeatMapViewFalse"><i class="icon icon--close-btn heatmap"></i></div>
      </div>
    </div>
    <div v-if="mode !== 'only'" class="heatmap__control-bar-bottom">
      <ui-tabs v-if="isDeviceAll" :item-list="deviceList" :on="device" @select="onDeviceChange"/>
      <ui-tabs v-if="device === 'desktop'" :item-list="getTypeList" :on="eventType" @select="onEventTypeChange"/>
      <ui-tabs v-else :item-list="getMobileTypeList" :on="eventType" @select="onEventTypeChange"/>
      <div class="pv"> <span class="num">{{ targetHeatmapPv[device] | thousand }}</span> PV </div>
    </div>
    <div class=scroll__wrap ref="heatmapsection" :class="{ loading: isLoading, only: mode === 'only' }">
      <heatmap-type v-if="['tap', 'zoom', 'swipe', 'path'].includes(eventType)"
        :eventType="eventType" :typeSource="typeSource" @onChangeTypeSource="onChangeTypeSource">
      </heatmap-type>
      <div v-if="mode !== 'only'" class="heatmap-option">
        <div class="view-mode" :style="{ top: onTypeView === '46px' ? '51px': '25px' }">
          <div class="fit-mode">
            <a class="mode" :class="{ on: fitMode === 'width' }" @click="setViewMode('width')"><i class="icon icon--fit-horizontal"></i></a>
            <a class="mode" :class="{ on: fitMode === 'height' }" @click="setViewMode('height')"><i class="icon icon--fit-vertical"></i></a>
          </div>
          <a class="heatmap button">
            <i class="icon icon--download-heatmap" @click="onHeatmapDownload"></i>
            <i class="tooltip">
              <span class="tooltip-text" v-html="$t('heatmap.journey.heatmap.tooltip')"></span>
            </i>
            <div v-if="isHeatmapDownloading" class="loading__wrap">
              <transition name="fade">
                <div class="small-loading">
                      <span class="loading-circle">
                        <svg x="0px" y="0px" viewBox="0 0 150 150">
                          <circle class="loading-inner" cx="75" cy="75" r="60"/>
                        </svg>
                      </span>
                </div>
              </transition>
            </div>
          </a>
          <a class="custom excel button" @click="setExcelData">
            <i class="icon icon--excel green"></i>
            <i class="tooltip">
              <span class="tooltip-text" v-html="$t('heatmap.journey.excel.tooltip')"></span>
            </i>
          </a>
          <div class="toggle__wrap">
            <a v-if="!isLogin" class="custom retake button" :class="{show: retake}" @click.prevent="viewRetake('open')">
              <i class="icon icon--retake" :class="retake ? 'white' : 'black'" :style="{ opacity: isInRange ? '1' : '0.3'}"></i>
              <i class="tooltip">
                <span class="tooltip-text" v-html="$t(`heatmap.journey.retake.tooltip.${ratakeType}`)"></span>
              </i>
              <div v-if="IsCaptureProcessing && !targetDeviceCapture" class="loading__wrap">
                <transition name="fade">
                  <div class="small-loading">
                        <span class="loading-circle">
                          <svg x="0px" y="0px" viewBox="0 0 150 150">
                            <circle class="loading-inner" cx="75" cy="75" r="60"/>
                          </svg>
                        </span>
                  </div>
                </transition>
              </div>
            </a>
            <div v-if="retake" class="retake-tooltip" :style="{ top: retakePosition }">
              <span class="retake-tooltip-close"><i class="icon icon--inquire-x" @click.stop="viewRetake('close')"></i></span>
              <template v-if="!IsCaptureProcessing || targetDeviceCapture">
                <span class="title">{{ $t('heatmap.journey.screenshot.title') }} </span>
                <div class="content" :class="{ disabled: showToastLayer}">
                  <ui-input-text :type="'text'"
                                :modelValue="retakeUrl"
                                :modelError="modelError"
                                :white="true"
                                :placeholder="isExactMatchType ? $t('heatmap.journey.screenshot.exactUrlPlaceholder') : $t('heatmap.journey.screenshot.urlPlaceholder')"
                                :size="'small'"
                                :dark-mode="true"
                                :is-input-above="false"
                                @onBlur="onUrlBlur"
                                @keyup="setUrl"
                                @input="setUrl">
                    {{ $t('heatmap.journey.screenshot.urlLabel') }}
                  </ui-input-text>
                </div>
                <div class="content" :class="{ disabled: showToastLayer}">
                  <div class="tooltip_wrap">
                    <span class="label">{{ $t('heatmap.journey.screenshot.cssLabel') }}</span>
                    <ui-icon-tooltip :iconSize="'small'" arrowBottom arrowCenter>
                      <span v-html="$t('heatmap.journey.screenshot.csstooltip')"></span>
                    </ui-icon-tooltip>
                  </div>
                  <div class="selector-exclude-radios">
                    <ui-radio :value="excludeCheck" :filled="true"
                              @input="excludeCheckChange(true)">
                      {{ $t('common.yes') }}
                    </ui-radio>
                    <ui-radio :value="!excludeCheck" :filled="true"
                              @input="excludeCheckChange(false)">
                      {{ $t('common.no') }}
                    </ui-radio>
                  </div>
                  <ui-input-text v-if="excludeCheck" :type="'text'"
                                :model-value="retakeCss"
                                :white="true"
                                :size="'small'"
                                :dark-mode="true"
                                :is-input-above="false"
                                margin-position="hidden"
                                :placeholder="$t('heatmap.journey.screenshot.cssPlaceholder')"
                                @input="setCssSelector">
                  </ui-input-text>
                </div>
                <div class="button--wrap" :class="{ disabled: showToastLayer || modelError}">
                  <button class="cancel" @click.stop="viewRetake('close')">{{ $t('heatmap.journey.screenshot.button.cancel') }}</button>
                  <button class="send" @click.stop="onScreenShotRecapture" :class="{'disabled': modelError}">{{ $t('heatmap.journey.screenshot.button.retake') }}</button>
                </div>
                <template v-if="showToastLayer">
                  <div class="content__toast">
                    <span>{{ $t('heatmap.journey.retake.completed.title') }}</span>
                    <i class="icon icon--check-green-size16"></i>
                  </div>
                </template>
              </template>
              <template v-else>
                <span class="title">{{ $t('heatmap.journey.screenshot.title') }}</span>
                <span class="sub">{{ $t('heatmap.journey.screenshot.subtitle') }}</span>
                <transition name="fade">
                  <div class="loading">
                    <span class="loading-circle">
                      <svg x="0px" y="0px" viewBox="0 0 150 150">
                        <circle class="loading-inner" cx="75" cy="75" r="60"/>
                      </svg>
                    </span>
                  </div>
                </transition>
                <span class="description" v-html="$t('heatmap.journey.screenshot.retakeDesc')"></span>
              </template>
            </div>
          </div>
          <div class="toggle__wrap">
            <a class="custom inquire button" :class="{ clicked: inquiry }" @click="viewInquire('open')">
              <i class="tooltip">
                <span class="tooltip-text" v-html="$t('heatmap.journey.inquire.tooltip')"></span>
              </i>
              <i class="icon icon--heatmap-inquiry"></i>
            </a>
            <div v-if="inquiry" class="inquire-tooltip" :style="{ top: inquirePosition }">
              <span class="inquire-tooltip-close"><i class="icon icon--inquire-x" @click.stop="viewInquire('close')"></i></span>
              <span class="title">{{ $t('heatmap.journey.inquire.title') }}</span>
              <span class="description">{{ $t('heatmap.journey.inquire.description') }}</span>
              <textarea class="input" :placeholder="$t('heatmap.journey.inquire.placeholder')"
                        v-model="model" @focus="modelError = ''"></textarea>
              <div class="button--wrap">
                <button :disabled="['success', 'error'].includes(state) || !model" class="button cancel" :class="{ disabled: ['success', 'error'].includes(state) || !model }" @click.stop="viewInquire('close')">{{ $t('common.cancel') }}</button>
                <button :disabled="['success', 'error'].includes(state) || !model" class="button send" :class="{ disabled: ['success', 'error'].includes(state) || !model }" @click.stop="onClaimSend">{{ $t('common.submit') }}</button>
                <div class="content__toast" v-if="showToastLayer">
                  <i class="icon icon--check-green-size16"></i>
                  <span>{{ $t('common.sendSuccess') }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="heatmap_colorrange" :style="getStyleColorRange()" v-if="['click', 'move', 'scroll'].includes(eventType)"
              :class="this.eventType === 'scroll' ? 'scroll' : 'regular'">
            <span class="hot">H</span>
            <span class="color-variation"></span>
            <span class="cold">C</span>
          </div>
        </div>
      </div>
      <div class="heatmap-outbox" :class="{ only_mode: mode === 'only' }">
        <!-- <heatmap-type v-if="['tap', 'zoom', 'swipe', 'path'].includes(eventType)"
                      :eventType="eventType" :typeSource="typeSource" @onChangeTypeSource="onChangeTypeSource"></heatmap-type> -->
        <div class="view-area" :style="{ width: mode === 'only' ? 'calc(100% - 80px)' : '740px', 'padding': mode === 'only' ? '20px' : '' , 'margin': mode === 'only' ? '0 20px' : '' }">
          <div class="heatmap-wrap" :class="{'only': mode === 'only'}">
            <div class="img-layer" :style="{
              width: computedContainerStyle.width + 'px',
              height: computedContainerStyle.height + 'px',
              backgroundImage: computedContainerStyle.backgroundImage,
              marginTop: isHeatmapOption ? '26px' : '0' }">
              <div class="heatmap-area">
                <heatmap-svg v-if="heatmap && !['scroll', 'path', 'swipe'].includes(eventType)"
                            :eventType="eventType"
                            :containerScale="containerScale"
                            :heatmap.sync="heatmap"
                            :scale="ratio" />

                <heatmap-scroll v-if="scrollData && eventType === 'scroll'"
                                :scrollData="scrollData"
                                :scale="ratio"
                                :fitMode="fitMode"
                                :containerWidth="containerStyle.width"
                                :containerHeight="containerStyle.height" />
                <heatmap-grid
                    v-if="gridData && (eventType === 'tap' || eventType === 'zoom')"
                    :gridData="gridData"
                    :heatmapType="typeSource"
                    :device="device"
                    :eventType="eventType"
                    :scale="ratio"
                    :containerScale="containerScale" />
                <heatmap-swipe
                    v-if="swipeData && eventType === 'swipe'"
                    :swipeData="swipeData"
                    :heatmapType="typeSource"
                    :device="device"
                    :eventType="eventType"
                    :scale="ratio"
                    :containerWidth="containerStyle.width"
                    :captureHeight="captureHeight"
                    :captureWidth="captureWidth"
                    :containerScale="containerScale"
                />
                <heatmap-stream v-if="streamData && eventType === 'path'"
                                :streamData="streamData" :device="'desktop'"
                                :scale="ratio" :containerScale="containerScale" :containerWidth="containerStyle.width"
                                :containerHeight="containerStyle.height" :activeSelector="activeSelector"
                                :userActionData="userActionData" :convertionType="eventSourceButtons[0]['type']" :scrollContainer="$refs.heatmapsection"
                                :isHeatmapDownloading="isHeatmapDownloading"
                                :path="path"
                                @onUserActionDataChange="$emit('onUserActionDataChange', $event)"
                                @onHeatmapCenterChange="onHeatmapCenterChange" />

                <heatmap-coords v-if="['click', 'tap', 'move', 'zoom', 'scroll'].includes(eventType)"
                                :rawCoords="rawCoords"
                                :scale="ratio"
                                :eventType="eventType"
                                :device="device"
                                :containerWidth="containerStyle.width"
                                :containerHeight="containerStyle.height"/>

                <template v-if="avgFold > 0 && mode !== 'only'">
                  <heatmap-avg-fold
                      :avgFoldData="avgFold"
                      :scale="ratio"
                      :fitMode="fitMode"
                  />
                </template>

              </div>
            </div>
          </div>
        </div>
      </div>
      <heatmap-dialog v-if="dialogType && mode !== 'only'"
                      :dialogType="dialogType"
                      @onTargetRefresh="onTargetRefresh"
                      @onCloseClick="dialogType = null"/>
      <download-error :isDownloading="isDownloading" @onDownloading="onDownloading"></download-error>
      <div v-if="isLoading" class="loading_indicator">
        <div class="loading circle">
          <svg x="0px" y="0px" viewBox="0 0 150 150">
            <circle class="loading-inner" cx="75" cy="75" r="60"/>
          </svg>
          <p class="loading_notice">{{ $t('common.loadingDot') }}</p>
        </div>
      </div>
      <div class="scroll_content-loading">
        <ui-loading-circle v-if="isHeatmapDownloading" :applyBackground="true"/>
      </div>
    </div>
    <!-- <div v-if="mode !== 'only'" class="fake__wrap">
      <div class="black">
        <div class="white-block left"></div>
        <div class="white-block right"></div>
      </div>
      <div class="white"></div>
    </div> -->
  </div>
</template>
<script>
import HeatmapSvg from './HeatMapSvg'
import HeatmapCoords from './HeatMapCoords'
import HeatmapScroll from './HeatMapScroll'
import HeatmapStream from './HeatMapStream'
import HeatmapAvgFold from './HeatmapAvgFold'
import HeatmapGrid from './HeatmapGrid'
import HeatmapSwipe from './HeatmapSwipe'
import HeatmapType from './HeatmapType'
import HeatmapDialog from './HeatmapDialog'
import DownloadError from './HeatmapDownloadError'
import AnimateScroll from '@/libs/animate-scroll'
import Excel from '@/libs/heatmap-excel-export'
import UiInputText from '@/components/ui/UiInputText'
import UiRadio from '@/components/ui/UiRadio'
import UiIconTooltip from '@/components/ui/UiIconTooltip'
import UiLoadingCircle from '@/components/ui/UiLoadingCircle'
import UiTabs from '@/components/ui/UiTabs'

import TrackingHistory from './TrackingHistory.vue'

import BaNeuButton from '@/components/ui/ba/ButtonNeu'
import BaPageNodeArrow from '@/components/journey/PageNodeArrow'

import {
  getHeatmapClickData,
  getScrollData,
  getStreamPathData,
  getSwipePathData,
  getCaptureImageUrl,
  reportProblem,
  requestCapture,
  updateBaApply,
  getAvgFoldData, getHeatmapImage, getHeatmapPV
} from '@/api/heatmap'
import { getNodeUsers } from '@/api/journey'
import { normalizeScrollData, normalizeStreamData, normalizeSwipeData, normalizeClickData } from '@/libs/report-data-normalizer'
import { mapState } from 'vuex'
import { isValidUrl } from '@/libs/validation-helper'
import { format, parse, startOfDay, endOfDay, differenceInDays, isWithinRange } from 'date-fns'
import { BEUSABLY_URL, isMatchedURL, getFromPageKey, getPercentage, getJourneyNodeKey } from '@/libs/utils'

export default {
  name: 'HeatMap',
  components: {
    HeatmapSvg,
    HeatmapCoords,
    HeatmapAvgFold,
    HeatmapScroll,
    HeatmapStream,
    HeatmapGrid,
    HeatmapSwipe,
    HeatmapType,
    UiInputText,
    UiLoadingCircle,
    UiRadio,
    UiIconTooltip,
    UiTabs,
    HeatmapDialog,
    DownloadError,
    BaNeuButton,
    BaPageNodeArrow,
    TrackingHistory
  },
  props: [
    'report',
    'isHeatMapView',
    'heatmapParams',
    'pageData',
    'wholeCaptureProcessing',
    'mode',
    'targetDeviceCapture',
    'seqDirection',
    'tracking'
  ],
  data () {
    return {
      device: null,
      isDeviceAll: false,
      targetHeatmapPv: {},
      showToastLayer: false,
      currentPv: null,
      heatmap: {},
      rawCoords: [],
      gridData: null,
      swipeData: null,
      streamData: null,
      scrollData: null,
      imageData: {},
      top10Clicks: [],
      captureWidth: 0,
      captureHeight: 0,
      containerStyle: {},
      heatmapStyle: {},
      containerScale: 1,
      ratio: 1,
      getTypeList: [
        { value: 'click' },
        { value: 'move' },
        { value: 'scroll' },
        { value: 'path' }
      ],
      getMobileTypeList: [
        { value: 'tap' },
        { value: 'zoom' },
        { value: 'swipe' },
        { value: 'scroll' }
      ],
      deviceList: [
        {
          name: 'desktop',
          icon: 'icon--device desktop',
          iconHover: 'icon--device desktop hover',
          iconActive: 'icon--device desktop on',
          label: 'Desktop',
          value: 'desktop'
        },
        {
          name: 'tablet',
          icon: 'icon--device tablet',
          iconHover: 'icon--device tablet hover',
          iconActive: 'icon--device tablet on',
          label: 'Tablet',
          value: 'tablet'
        },
        {
          name: 'phone',
          icon: 'icon--device phone',
          iconHover: 'icon--device phone hover',
          iconActive: 'icon--device phone on',
          label: 'Phone',
          value: 'phone'
        }
      ],
      eventType: 'click',
      fitMode: 'width',
      isHeatmapDownloading: false,
      activeSelector: null,
      userActionData: null,
      eventSourceButtons: [
        {
          key: 'conversion',
          t: 'heatmap.segment.tooltip.conversion',
          type: true
        },
        {
          key: 'lastOrder',
          t: 'heatmap.segment.tooltip.lastOrder',
          type: true
        }
      ],
      segmentList: [
        {
          value: 'all',
          text: 'All'
        },
        {
          value: true,
          text: 'TRUE'
        },
        {
          value: false,
          text: 'FALSE'
        }
      ],
      selectedSegment: { reload: 'all', rollback: 'all' },
      path: 'engage',
      zoom: 0,
      swipe: 0,
      avgFold: 0,
      pathDetail: false,
      inquiry: false,
      isLoadedOnce: false,
      isPvLoaded: false,
      state: 'input',
      model: '',
      retakeUrl: null,
      retakeCss: null,
      retake: false,
      excludeCheck: false,
      modelError: '',
      typeSource: 0,
      dialogType: null,
      reportView: 'journey',
      periodDays: 0,
      eventDays: 0,
      scrollGap: null,
      maxGap: null,
      isHeatmapOption: false,
      isDownloading: false,
      isLoading: false,
      loadingWrapHeight: 0,
      offsetDistance: 0,
      originHeight: 0,
      sessionCacheKey: null
    }
  },
  watch: {
    captureWidth () {
      // this.getContainerStyle()
    },
    fitMode () {
      this.getContainerStyle()
    },
    modelError () {
      if (this.modelError) {

      }
    }
  },
  computed: {
    ...mapState([
      'journeyPeriod',
      'devicelist',
      'journeyOptions',
      'journeyTargetingOptions',
      'basicInfo',
      'domain',
      'userData',
      'journeyExcelData'
    ]),
    isExactMatchType () {
      return this.domain.matchType === 'exact' || this.journeyOptions.matchType === 'exact'
    },
    aid () {
      return this.pageData.heatmapAid
    },
    isLogin () {
      return this.pageData.baApply.bLogin
    },
    isInRange () {
      const range = this.journeyPeriod
      const date = format(new Date(), 'YYYY-MM-DD')
      if (range.start && range.end && isWithinRange(date, range.start, range.end)) {
        return true
      } else {
        return false
      }
    },
    ratakeType () {
      if (this.isInRange) {
        return 'retake'
      } else {
        return 'notInRange'
      }
    },
    retakePosition () {
      // if (!['tap', 'zoom', 'swipe', 'path'].includes(this.eventType)) {
      //   return '370px'
      // } else {
      //   return '414px'
      // }
      return '100%'
    },
    computedData () {
      if (this.journeyOptions.matchType !== 'exact' && this.pageData.key && typeof this.pageData.key === 'string' && this.pageData.key.indexOf('|') > -1) {
        // trend , targeting
        return getFromPageKey(this.pageData.key)
      } else {
        // ranking , journey
        return {
          ...this.pageData,
          // sid: this.journeyOptions.sid,
          urlId: this.pageData.gUrlId || this.pageData.key, // key -> journey
          sid: this.journeyOptions.sid,
          matchType: this.journeyOptions.matchType
        }
      }
    },
    inquirePosition () {
      // if (!this.isLogin && !['tap', 'zoom', 'swipe', 'path'].includes(this.eventType)) {
      //   return '401px'
      // } else if (!this.isLogin && ['tap', 'zoom', 'swipe', 'path'].includes(this.eventType)) {
      //   return '445px'
      // } else if (!this.isLogin && ['tap', 'zoom', 'swipe', 'path'].includes(this.eventType)) {
      //   return '371px'
      // } else if (this.pageData.baApply.bLogin) {
      //   return '375px'
      // } else {
      //   return '415px'
      // }
      return '100%'
    },
    refreshSegmentList () {
      return [
        {
          value: 'all',
          text: this.$t(`common.all`)
        },
        {
          value: true,
          text: this.$t(`common.yes`)
        },
        {
          value: false,
          text: this.$t(`common.no`)
        }
      ]
    },
    rollbackSegmentList () {
      return [
        {
          value: 'all',
          text: this.$t(`common.all`)
        },
        {
          value: true,
          text: this.$t(`common.yes`)
        },
        {
          value: false,
          text: this.$t(`common.no`)
        }
      ]
    },
    computedContainerStyle () {
      return {
        width: this.containerStyle.width,
        height: this.containerStyle.height,
        backgroundImage: `url(${this.imageUrl})`
      }
    },
    IsCaptureProcessing () {
      let label = false
      for (let index = 0; index < this.wholeCaptureProcessing.length; index++) {
        if ((this.wholeCaptureProcessing[index]['aid'] === this.aid) && (this.wholeCaptureProcessing[index]['state'] === null)) {
          label = true
          if (this.targetDeviceCapture) {
            this.showCaptureResult()
          }
        } else {
          if (this.wholeCaptureProcessing[index]['state'] === 'success') {
            this.captureSuccessed(index)
          } else {
            this.captureFailed(index)
          }
          label = false
        }
      }
      return label
    },
    onTypeView () {
      if (['tap', 'zoom', 'swipe', 'path'].includes(this.eventType)) {
        return '46px'
      } else {
        return '0px'
      }
    },
    isImageExceedContainer () {
      if (this.scrollGap) {
        return `calc(100% - 140px - ${this.scrollGap}px)`
      } else {
        return 'calc(100% - 140px)'
      }
    },
    fileName () {
      let fileName = ''

      let device = this.heatmapParams.device || this.journeyOptions.device || 'desktop'

      fileName += this.pageData.title.replace(/&/gi, '%26').replace(/%/gi, '%25').replace(/[\t\\/:*?"'<>|]/gi, '')

      fileName += '_'
      fileName += this.journeyPeriod.start.replace(/[-]/gi, '') + '-' + this.journeyPeriod.end.replace(/[-]/gi, '')

      fileName += '_'
      fileName += device.charAt(0).toUpperCase()

      fileName += '_'
      if (this.journeyOptions.refer) {
        fileName += this.journeyOptions.refer.replace(/&/gi, '%26').replace(/%/gi, '%25').replace(/[\t\\/:*?"'<>|]/gi, '')
      } else {
        fileName += 'All'
      }

      fileName += '_'
      let eventSource = this.journeyOptions.exist === null ? 'All' : (this.journeyOptions.exist ? 'ret' : 'new')
      fileName += eventSource.charAt(0).toUpperCase() + eventSource.slice(1, 3)

      fileName += '_'
      if (this.eventType === 'path') {
        fileName += 'P'
      } else if (this.eventType === 'zoom') {
        fileName += ['Z-I', 'Z-O'][this.typeSource]
      } else if (this.eventType === 'swipe') {
        fileName += ['SW-V', 'SW-H'][this.typeSource]
      } else {
        fileName += this.eventType.charAt(0).toUpperCase()
      }
      if (this.eventType === 'path') {
        fileName += '_'
        if (this.typeSource === 0) {
          fileName += 'FAN'
        } else {
          fileName += 'Avg'
        }
      }

      fileName += '.png'
      return fileName
    },
    pageSeqData () {
      const seq = this.pageData.seq || this.pageData._seq
      // console.log(this.seqDirection === 'backward' && seq > 0)
      return `${this.seqDirection === 'backward' && seq > 0 ? '-' : ''} ${seq}`
    },
    isPrevArrow () {
      return (
        !(this.seqDirection === 'backward' && (this.pageData._seq >= 6 || this.pageData._children.length === 0))
      )
    },
    isNextArrow () {
      const limitSeq = this.seqDirection === 'forward' ? this.pageData._seq < 6 : true
      return (this.pageData.dropCnt !== this.pageData.sessCnt || limitSeq)
    }
  },
  methods: {
    getStyleColorRange () {
      if (this.pageData.baApply.bLogin) {
        return { 'top': '147px' }
      } else {
        return {}
      }
    },
    onTargetRefresh () {
      this.$emit('onTargetRefresh')
    },
    onChangeSwipeType (value) {
      this.swipe = value
    },
    onHeatmapDownload () {
      this.isHeatmapDownloading = true

      let host = `${location.protocol}//${location.hostname}`
      if (location.port) {
        host += `:${location.port}`
      }

      let heatmapUrl = `${host}/heatmap/${this.pageData.heatmapAid}`

      const params = {
        paramData: {
          event: this.eventType,
          start: this.journeyPeriod.start,
          end: this.journeyPeriod.end,
          device: this.journeyOptions.device,
          existing: this.journeyOptions.exist,
          refer: this.journeyOptions.refer,
          aiRefererIds: this.journeyOptions.aiRefererIds,
          utm: this.journeyOptions.utm,
          selectedSegment: this.selectedSegment,
          eventSourceButtons: this.eventSourceButtons,
          domain: this.domain,
          pageData: this.pageData,
          currentPv: this.targetHeatmapPv[this.device],
          reportView: this.reportView,
          lang: this.$i18n.locale,
          ...this.heatmapParams
        },
        url: heatmapUrl,
        aid: this.aid,
        device: this.heatmapParams.device || this.journeyOptions.device,
        userId: this.userData.userId
      }

      if (['swipe', 'zoom'].includes(this.eventType)) {
        params.paramData.typeSource = this.typeSource
      }

      if (params.paramData.pageData._parent) {
        delete params.paramData.pageData._parent
      }
      if (params.paramData.pageData._children) {
        delete params.paramData.pageData._children
      }

      localStorage.setItem('paramData', JSON.stringify(params.paramData))

      getHeatmapImage(params).then(async result => {
        if (result.data.success) {
          const data = result.data.data
          const downloadUrl = `${BEUSABLY_URL}/viewer/beusable_capture/download/${this.pageData.heatmapAid}/${data.filename}?filename=${this.fileName}`

          const link = document.createElement('a')
          link.href = downloadUrl
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)

          this.isHeatmapDownloading = false
        } else {
          this.isHeatmapDownloading = false
          this.onDownloading('error')
        }
      }).catch(err => {
        console.error(err)
        this.isHeatmapDownloading = false
        this.onDownloading('error')
      })
    },
    captureSuccessed (index) {
      let original = this.wholeCaptureProcessing
      original.splice(index, 1)
      this.$emit('onWholeCaptureProcessingChange', original)
      this.showCaptureResult()
    },
    captureFailed (index) {
      let original = this.wholeCaptureProcessing
      original.splice(index, 1)
      this.$emit('onWholeCaptureProcessingChange', original)
      this.showCaptureResult()
    },
    showCaptureResult () {
      this.viewRetake('open')
      this.showToastLayer = true
      setTimeout(() => {
        this.showToastLayer = false
        this.retake = false
        this.loadCaptureImage()
      }, 2000)
    },
    loadCaptureImage () {
      const params = { aid: this.aid, device: this.device, startDate: this.journeyPeriod.start, endDate: this.journeyPeriod.end }
      return getCaptureImageUrl(params, this.captureImageTimestamp).then(async imageUrl => {
        this.imageUrl = imageUrl
        await this.getImgContainer()
      }).catch(err => {
        console.error(err)
        this.showHeatmapDialog('noPVByDevice')
      })
    },
    getImgContainer () {
      if (!this.imageUrl) {
        this.captureWidth = 0
        this.captureHeight = 0
      } else {
        const img = document.createElement('img')
        img.addEventListener('load', event => {
          const el = event.target
          this.captureWidth = el.width
          this.captureHeight = el.height
          this.getContainerStyle()
        })
        img.src = this.imageUrl
      }
    },
    getContainerStyle () {
      let containerWidth = this.$refs.heatmapsection.offsetWidth
      let containerHeight = this.$refs.heatmapsection.offsetHeight - 40
      // let originalContainerHeight = this.$refs.heatmapsection.offsetHeight

      if (this.mode !== 'only') containerWidth -= 80
      if (this.device === 'phone') containerWidth -= 262

      if (this.mode === 'only') {
        containerWidth = 700 - 80
        if (this.device === 'phone') {
          containerWidth = 438 - 80
        }
      }
      this.isHeatmapOption = ['path', 'tap', 'zoom', 'swipe'].includes(this.eventType)

      if (this.fitMode === 'width') {
        this.ratio = containerWidth / this.captureWidth
        this.containerStyle = {
          width: containerWidth,
          height: this.captureHeight * this.ratio
        }
        this.containerScale = 1
      } else {
        if (['path', 'tap', 'zoom', 'swipe'].includes(this.eventType)) {
          containerHeight -= 46
        }

        this.ratio = (containerHeight) / this.captureHeight
        this.containerStyle = {
          width: (this.captureWidth * this.ratio),
          height: (this.captureHeight * this.ratio)
        }
        this.containerScale = containerHeight / this.captureHeight
      }
      // console.log(originalContainerHeight)
      const optGap = this.isHeatmapOption ? 26 : 0
      // even bottom of layer has left
      if (this.containerStyle.height && (this.containerStyle.height < (containerHeight + optGap))) {
        const maxgap = (this.containerStyle.height + 40 + optGap)
        const value = this.originHeight - maxgap
        this.scrollGap = value
        this.maxGap = maxgap + 'px'
      }

      // if (!this.isLoadedOnce && this.eventType === 'click') {
      //   // this.segmentSelector(this.heatmapParams)
      //   // this.isLoadedOnce = true
      // } else if (!this.isLoadedOnce && this.eventType === 'tap') {
      //   // this.segmentSelector(this.heatmapParams)
      //   // this.isLoadedOnce = true
      // }

      this.segmentSelector()
    },
    setViewMode (boolean) {
      this.fitMode = boolean
    },
    setHeatMapViewFalse () {
      this.$emit('setHeatMapView', false)
    },
    onEventTypeChange (item) {
      this.eventType = item
      this.isLoadedOnce = false
      this.typeSource = 0
      this.getContainerStyle()
    },
    async onDeviceChange (item) {
      this.device = item
      this.eventType = this.device === 'desktop' ? 'click' : 'tap'
      this.isLoadedOnce = false
      await this.loadCaptureImage()
    },
    loadScrollData (payload) {
      payload.event = this.eventType
      return getScrollData(payload, this.reportView, true).then(data => {
        if (!data || Object.entries(data).length <= 1) {
          throw new Error('NO_SCROLL_DATA')
        }
        this.scrollData = normalizeScrollData(data, this.captureHeight, payload)
        this.scrollData.avgFold = data.avgfold
        this.avgFold = data.avgfold
        this.dataChecker(data)
        this.isLoading = false
        return this.scrollData
      }).catch((err) => {
        this.isLoading = false
        if (err.message === 'Expired redisKey') {
          this.showHeatmapDialog('expireRedisKey')
        }
      })
    },
    loadHeatMapData (payload) {
      payload.event = this.eventType
      return getHeatmapClickData(payload, this.reportView, true).then((res) => {
        this.heatmap = []
        if (['click', 'tap', 'zoom'].includes(this.eventType)) {
          this.rawCoords = normalizeClickData(res, this.targetHeatmapPv[this.device], this.device, this.captureWidth, this.captureHeight)
          this.heatmap = res.heatmap
        } else {
          this.heatmap = res.heatmap
        }
        this.eventDays = res.dates.length
        // this.getContainerStyle()
        this.dataChecker(res)
        this.isLoading = false
        return this.rawCoords
      }).catch((err) => {
        // console.log(err)
        this.isLoading = false
        if (err.message === 'Expired redisKey') {
          this.showHeatmapDialog('expireRedisKey')
        }
      })
    },
    loadStreamData (payload) {
      payload.event = this.eventType
      payload.core = this.typeSource === 0
      let loadStart = Date.now()
      return getStreamPathData(payload, this.reportView).then(data => {
        if (!data || !data.cache) {
          let loadEnd = Date.now()
          while (loadEnd - loadStart < 1000) {
            loadEnd = Date.now()
          }
        }
        this.streamData = normalizeStreamData(data, this.captureWidth, this.captureHeight)
        this.dataChecker(data)
        this.isLoading = false
        return this.streamData
      }).catch((err) => {
        this.isLoading = false
        if (err.message === 'Expired redisKey') {
          this.showHeatmapDialog('expireRedisKey')
        }
      })
    },
    loadSwipeData (payload) {
      const params = payload
      params.event = 'swipe'
      return getSwipePathData(params, this.reportView).then(data => {
        if (!data || Object.entries(data).length <= 1) {
          throw new Error('NO_SCROLL_DATA')
        }

        const makeMoreSwipeData = (rawData) => {
          rawData = normalizeSwipeData(rawData)
          let dataMade = [{
            left: [],
            right: []
          }, {
            left: [],
            right: []
          }]
          for (let i = 0; i <= Math.floor(this.captureHeight / 100) + 1; i++) {
            for (let j = 0; j < 2; j++) {
              for (const position of ['left', 'right']) {
                dataMade[j][position].push(rawData[j][position][i] || 0)
              }
            }
          }
          for (let j = 0; j < 2; j++) {
            for (const position of ['left', 'right']) {
              dataMade[j][`${position}Total`] = dataMade[j][position].reduce((a, b) => a + b, 0)
            }
            dataMade[j].min = dataMade[j].left.concat(dataMade[j].right).reduce((a, b) => Math.min(a, b), Infinity)
            dataMade[j].max = dataMade[j].left.concat(dataMade[j].right).reduce((a, b) => Math.max(a, b), 0)
            for (const position of ['left', 'right']) {
              dataMade[j][`${position}Percent`] = dataMade[j][position].map((a) => (dataMade[j][`${position}Total`] > 0 ? (a / dataMade[j][`${position}Total`]) : 0))
              dataMade[j][`${position}Rate`] = dataMade[j][position].map((a) => (dataMade[j].max !== dataMade[j].min ? ((a - dataMade[j].min) / (dataMade[j].max - dataMade[j].min)) : 0))
            }
          }
          return dataMade
        }

        this.swipeData = makeMoreSwipeData(data)
        this.dataChecker(data)
        this.isLoading = false
        return this.swipeData
      }).catch((err) => {
        this.isLoading = false
        if (err.message === 'Expired redisKey') {
          this.showHeatmapDialog('expireRedisKey')
        }
      })
    },
    segmentSelector (type) {
      if (type !== 'excel') {
        this.isLoading = true
      }
      let params = {
        start: this.journeyPeriod.start,
        end: this.journeyPeriod.end,
        existing: this.journeyOptions.exist,
        refer: this.journeyOptions.refer,
        aiRefererIds: this.journeyOptions.aiRefererIds,
        utm: this.journeyOptions.utm,
        survey: this.journeyOptions.survey,
        ...this.heatmapParams,
        device: this.device,
        event: this.eventType
      }

      if (this.sessionCacheKey) {
        params.redisKey = this.sessionCacheKey
      }

      if (this.eventSourceButtons[0]['type'] === true && this.eventSourceButtons[1]['type'] === true) {
        delete params.lastOrder
        delete params.conversion
      } else {
        params['lastOrder'] = this.eventSourceButtons[1]['type']
      }
      if (this.selectedSegment.reload === 'all' && this.selectedSegment.rollback === 'all') {
        delete params.reload
        delete params.rollback
      } else {
        params = { ...params, ...this.selectedSegment }
      }
      if (this.selectedSegment.reload === 'all' && this.selectedSegment.rollback !== 'all') {
        delete params.reload
      }
      if (this.selectedSegment.reload !== 'all' && this.selectedSegment.rollback === 'all') {
        delete params.rollback
      }
      if (this.pageData.baApply) {
        params.sid = this.pageData.baApply.sid.substring(1, this.pageData.baApply.sid.length)
        params.parentSid = this.pageData.baApply.parentSid.substring(1, this.pageData.baApply.parentSid.length)
      }
      if (this.reportView === 'target') {
        params.url = this.pageData.url
      }

      this.$emit('changeHeatmapParams', params)
      return this.loadSelector(params)
    },
    loadGridData (payload) {
      const params = payload
      if (this.eventType === 'tap') {
        params.event = 'tap'
        this.heatmap = []
        return getHeatmapClickData(params, this.reportView, true).then(data => {
          this.heatmap = data.tapHeatmap
          this.gridData = null
          this.gridData = [data.doubletapHeatmap]
          data.topClicks = data.topTaps
          this.rawCoords = normalizeClickData(data, this.targetHeatmapPv[this.device], this.device, this.captureWidth, this.captureHeight)
          this.dataChecker(data)
          this.isLoading = false
          return this.rawCoords
        }).catch((err) => {
          this.isLoading = false
          if (err.message === 'Expired redisKey') {
            this.showHeatmapDialog('expireRedisKey')
          }
        })
      } else if (this.eventType) {
        return Promise.all([
          getHeatmapClickData({
            ...params,
            event: 'zoomin'
          }, this.reportView),
          getHeatmapClickData({
            ...params,
            event: 'zoomout'
          }, this.reportView)
        ]).then(data => {
          this.heatmap = null
          this.gridData = null
          this.gridData = [data[0].heatmap, data[1].heatmap]
          data[0].topZoomin = data[0].topZooms
          data[0].topZoomout = data[1].topZooms
          const mergedData = {
            ...data[0],
            dom: {
              ...data[0].dom,
              ...data[1].dom
            }
          }
          this.rawCoords = normalizeClickData(mergedData, this.targetHeatmapPv[this.device], this.device, this.captureWidth, this.captureHeight)
          this.dataChecker(data[0])
          this.isLoading = false
          return this.rawCoords
        }).catch((err) => {
          this.isLoading = false
          if (err.message === 'Expired redisKey') {
            this.showHeatmapDialog('expireRedisKey')
          }
        })
      }
    },
    onHeatmapCenterChange (center) {
      const container = this.$refs.container
      const containerPadding = 20

      const containerCenter = {
        left: container.offsetWidth / 2 - containerPadding,
        top: container.offsetHeight / 2 - containerPadding
      }
      const offsetTop = Math.max(0, center.top - containerCenter.top)

      if (!this.scroller) {
        this.scroller = new AnimateScroll(container)
      }

      this.scroller.scrollTo(offsetTop, 300)
    },
    setEventSource (key, idx, type) {
      this.isPvLoaded = false
      if (key === 'lastOrder' && type === false && this.eventSourceButtons[0]['type'] === false) {
        this.eventSourceButtons[0]['type'] = true
        this.eventSourceButtons[1]['type'] = false
        this.segmentSelector()
        return false
      }
      if (key === 'lastOrder' && type === false && this.eventSourceButtons[0]['type'] === true) {
        this.eventSourceButtons[1]['type'] = false
        this.segmentSelector()
        return false
      }
      if (key === 'lastOrder' && type === true) {
        this.eventSourceButtons[1]['type'] = true
        this.segmentSelector()
        return false
      }
      if (key === 'conversion' && type === false && this.eventSourceButtons[1]['type'] === false) {
        this.eventSourceButtons[0]['type'] = false
        this.eventSourceButtons[1]['type'] = true
        this.segmentSelector()
        return false
      }
      if (key === 'conversion' && type === false && this.eventSourceButtons[1]['type'] === true) {
        this.eventSourceButtons[0]['type'] = false
        this.segmentSelector()
        return false
      }
      if (key === 'conversion' && type === true) {
        this.eventSourceButtons[0]['type'] = true
        this.segmentSelector()
        return false
      }
      this.segmentSelector()
    },
    onSegmentChange (value, target) {
      this.selectedSegment[target] = this.selectedSegment[target] === value ? !value : this.selectedSegment[target] === 'all' ? !value : 'all'
      this.isPvLoaded = false
      this.segmentSelector()
    },
    async loadSelector (params) {
      this.clearData()

      if (!this.isPvLoaded) {
        const targetDevice = this.isDeviceAll ? ['desktop', 'tablet', 'phone'] : [this.device]

        for (const device of targetDevice) {
          await getHeatmapPV({ ...params, device }, this.reportView).then(res => {
            this.targetHeatmapPv[device] = res ? res.pv : 0
          }).catch((err) => {
          // console.log(err)
            this.isLoading = false
            if (err.message === 'Expired redisKey') {
              this.showHeatmapDialog('expireRedisKey')
            }
          })
        }

        if (this.isDeviceAll) {
          const totalPV = Object.values(this.targetHeatmapPv).reduce((acc, value) => acc + value, 0)
          for (const [idx, device] of targetDevice.entries()) {
            this.deviceList[idx].label = getPercentage(this.targetHeatmapPv[device], totalPV).toFixed(1) + '%'
          }
        }
        this.isPvLoaded = true
      }

      if (!this.isLoadedOnce) {
        await getAvgFoldData(params, this.reportView).then(res => {
          this.avgFold = res
        }).catch((err) => {
          // console.log(err)
          this.isLoading = false
          if (err.message === 'Expired redisKey') {
            this.showHeatmapDialog('expireRedisKey')
            return false
          }
        })

        if (this.eventType === 'scroll') {
          return this.loadScrollData(params)
        } else if (['click', 'move'].includes(this.eventType)) {
          return this.loadHeatMapData(params)
        } else if (this.eventType === 'path') {
          return this.loadStreamData(params)
        } else if (['tap', 'zoom'].includes(this.eventType)) {
          return this.loadGridData(params)
        } else if (this.eventType === 'swipe') {
          return this.loadSwipeData(params)
        }
      }
    },
    onChangeTypeSource (value) {
      this.typeSource = value
      this.segmentSelector()
    },
    viewInquire (state) {
      if (state === 'open') {
        this.state = 'open'
        this.inquiry = true
        this.retake = false
      } else {
        this.inquiry = false
      }
    },
    viewRetake (state) {
      if (!this.isInRange) {
        return null
      }
      if (state === 'open') {
        this.retake = true
        this.inquiry = false
        this.retakeUrl = this.pageData.baApply.captureURL || this.pageData.baApply.url
        this.setUrl(this.retakeUrl)
        this.setCssSelector(this.pageData.baApply.exceptionSelector)
      } else {
        this.retake = false
        this.retakeUrl = ''
        this.retakeCss = ''
      }
    },
    clearData () {
      this.dialogType = null
      this.avgFold = null
      this.svgData = null
      this.gridData = null
      this.coordsData = null
      this.swipeData = null
      // this.heatmap = null
      // this.rawCoords = null
      this.scrollData = null
      this.streamData = null
      // this.typeSource = 0
    },
    dataChecker () {
      let flag = true
      const startDate = startOfDay(parse(this.journeyPeriod.start))
      const streamMinDate = startOfDay('2019-12-01')
      if (this.targetHeatmapPv[this.device] === 0) {
        this.showHeatmapDialog('noPVByDevice')
        return
      }
      if (['click', 'tap', 'move'].includes(this.eventType)) {
        if (!this.heatmap || !Object.keys(this.heatmap).length) {
          if (this.eventType === 'click') {
            this.showHeatmapDialog('noClickEvent')
          } else if (this.eventType === 'tap') {
            this.showHeatmapDialog('noTapEvent')
          } else if (this.eventType === 'move') {
            this.showHeatmapDialog('noMoveEvent')
          }
          flag = false
        }
      } else if (this.eventType === 'zoom') {
        if (!this.gridData || !Object.keys(this.gridData).length ||
            !(this.gridData[0] && this.gridData[1]) || (!Object.keys(this.gridData[0]).length && !Object.keys(this.gridData[1]).length)) {
          this.showHeatmapDialog('noZoomEvent')
          flag = false
        }
      } else if (this.eventType === 'swipe') {
        if (!this.swipeData || !Object.keys(this.swipeData).length ||
            !(this.swipeData[0] && this.swipeData[1]) || (!(this.swipeData[0].left && this.swipeData[0].left.length > 0) &&
                !(this.swipeData[0].right && this.swipeData[0].right.length > 0) &&
                !(this.swipeData[1].left && this.swipeData[1].left.length > 0) &&
                !(this.swipeData[1].right && this.swipeData[1].right.length > 0))) {
          this.showHeatmapDialog('noSwipeEvent')
          flag = false
        }
      } else if (this.eventType === 'scroll' && (!this.scrollData)) {
        this.showHeatmapDialog('noEnoughPv')
        flag = false
      } else if (this.eventType === 'path') {
        const hasUnsupportedDate = startDate < streamMinDate

        if (!this.streamData) {
          if (hasUnsupportedDate) {
            this.showHeatmapDialog('noStreamEventIncludeNoStreamDate')
          } else {
            this.showHeatmapDialog('noStreamEvent')
          }
        } else {
          if (hasUnsupportedDate) {
            this.showHeatmapDialog('includeNoStreamDate')
          } else {
            if (this.streamData.hasNoCoordsItem && !this.streamData.path.length) {
              this.showHeatmapDialog('noStreamDisplay')
            }
          }
        }
      }
      if (flag) {
        return true
      } else {
        return false
      }
    },
    setExcelData () {
      const reportData = {
        image: {
          url: this.imageUrl,
          width: this.captureWidth,
          height: this.captureHeight
        },
        device: this.device,
        eventSource: this.journeyOptions.exist,
        activityStatistics: 'extreme',
        marketing: this.journeyOptions.utm || this.journeyOptions.survey,
        data: null,
        pageData: this.pageData,
        selectedSegment: this.selectedSegment
      }
      // console.log(reportData)
      const isCaptureHeightExceed = this.captureHeight >= 32767

      const endDate = endOfDay(parse(this.journeyPeriod.end))
      const streamMinDate = startOfDay(parse(reportData.activityStatistics === 'extreme' ? '2019-12-01' : '2019-09-30'))

      this.$nextTick().then(() => {
        const tasks = []
        switch (this.eventType) {
          case 'click':
          case 'move':
            tasks.push(this.segmentSelector('excel'))
            break
          case 'tap':
          case 'zoom':
            tasks.push(this.segmentSelector('excel'))
            break
          case 'swipe':
            tasks.push(this.segmentSelector('excel'))
            break
          case 'scroll':
            if (this.device !== 'desktop') {
            }
            tasks.push(this.segmentSelector('excel'))
            break
          case 'path':
            reportData.core = this.typeSource === 0
            if (endDate < streamMinDate) {
              tasks.push(Promise.reject(new Error('STREAM_UNSUPPORTED_DATE')))
            } else {
              tasks.push(this.segmentSelector('excel'))
            }
            break
        }
        Promise.all(tasks).then(result => {
          switch (this.eventType) {
            case 'click':
            case 'tap':
            case 'move':
            case 'zoom':
            case 'swipe':
            case 'path':
              reportData.data = result[0]
              break
            case 'scroll':
              reportData.data = {
                scroll: result[0]
              }
              break
          }
          const flag = this.dataChecker(reportData)
          if (flag) {
            this.onExcelExport(reportData)
          } else {
            return true
          }
        }).catch(err => {
          if (err.message === 'NO_SCROLL_DATA') {
            this.showHeatmapDialog('noEventByDate')
            this.isCaptureHeightExceed = isCaptureHeightExceed
          } else if (err.message === 'STREAM_UNSUPPORTED_DATE') {
            this.showHeatmapDialog('noStreamByDate')
          } else {
          }
        })
      })
    },
    optionSelect () {
      let option = {}
      if (this.eventType === 'click') {
        option = { highlight: 'J' }
      } else if (this.eventType === 'scroll') {
        option = { highlight: 'F' }
      } else if (this.eventType === 'move') {
        option = { highlight: 'J' }
      } else if (this.eventType === 'swipe') {
        option = { heatmapType: ['vert', 'horiz'][this.typeSource] }
      } else if (this.eventType === 'tap') {
        option = { highlight: 'J' }
      } else if (this.eventType === 'zoom') {
        option = { heatmapType: ['in', 'out'][this.typeSource], highlight: 'J' }
      } else if (this.eventType === 'path') {
        option = { heatmapType: ['engage', 'aver'][this.typeSource], highlight: 'J' }
      }
      return option
    },
    excelSelect (reportData) {
      let excelData = {}
      if (this.eventType === 'click') {
        excelData = Object.values(reportData.data.coords).sort((a, b) => {
          return b['clickCount'] - a['clickCount']
        })
      } else if (this.eventType === 'scroll') {
        excelData = reportData.data.scroll
      } else if (this.eventType === 'move') {
        excelData = Object.values(reportData.data.coords).sort((a, b) => {
          return b['hoverCnt'] - a['hoverCnt']
        })
      } else if (this.eventType === 'swipe') {
        excelData = reportData
      } else if (this.eventType === 'tap') {
        excelData = Object.values(reportData.data.coords).sort((a, b) => {
          return b['tapCount'] - a['tapCount']
        })
      } else if (this.eventType === 'zoom') {
        excelData = Object.values(reportData.data.coords).sort((a, b) => {
          return b['zoomin'] - a['zoomin']
        })
      } else if (this.eventType === 'path') {
        excelData = reportData.data.path
      }
      return excelData
    },
    onExcelExport (reportData) {
      const applyData = {
        pageName: 'journey',
        url: this.pageData.linkUrl
      }
      const option = this.optionSelect()
      const excelData = this.excelSelect(reportData)
      let fileName = applyData.pageName + '_' + this.eventType
      let excel = new Excel()
      this.onDownloading(true)
      excel.setReportInfo(applyData, this.basicInfo, reportData, this.heatmapParams, this.journeyOptions.utm, this.journeyOptions.survey, this.refreshSegmentList, this.rollbackSegmentList, this.targetHeatmapPv[this.device])
        .then(
          excel.setReportData(this.eventType, reportData, excelData || [], reportData.image.url, option, this.captureHeight)
            .then(result => {
              excel.download(fileName)
              this.onDownloading(false)
            })
        )
    },
    onClaimSend () {
      if (!this.model.length) {
        this.modelError = 'required'
        return false
      }

      this.state = 'sending'
      const urlObj = new URL(this.pageData.baApply.captureURL || this.pageData.baApply.url)

      let param = {
        aid: this.aid,
        heatmapUrl: urlObj.origin + urlObj.pathname,
        url: location.href,
        content: this.model,
        serviceType: 'ba'
      }
      reportProblem(param).then((resp) => {
        if (resp === 'Success') {
          this.showToastLayer = true
          setTimeout(() => {
            this.showToastLayer = false
            // this.inquiry = false
            this.model = ''
          }, 2000)
        }
        this.state = 'success'
      }).catch(() => {
        this.state = 'error'
      })
    },
    onScreenShotRecapture () {
      const nodeHost = this.pageData.linkHost
      const nodeTarget = this.pageData.linkPath
      if (!isMatchedURL(nodeHost, nodeTarget, this.retakeUrl)) {
        this.modelError = 'unAbleDomain'
        return false
      }
      if (!isValidUrl(this.retakeUrl)) {
        this.modelError = 'unAbleDomain'
        return false
      } else {
        this.$emit('onCapture', this.device)
        this.modelError = ''
        const payload = {
          id: this.aid,
          captureURL: this.retakeUrl,
          exceptionSelector: this.retakeCss
        }

        if (!this.excludeCheck) {
          payload.exceptionSelector = ''
        }

        updateBaApply(payload).then(result => {
          if (result) {
            const params = `/${this.aid}`
            requestCapture(params).then(result => {
              if (result.data) {
                let arr = this.wholeCaptureProcessing
                arr.push({
                  aid: this.aid,
                  requestId: result.data.requestId,
                  uuid: result.data.uuid,
                  state: null
                })
                this.$emit('onCaptureProcessing', this.computedData)
                this.$emit('onWholeCaptureProcessingChange', arr)
              }
            }).catch((err) => {
              console.log(err)
            })
          }
        })
      }
    },
    setUrl (value) {
      if (value) {
        this.retakeUrl = value
      }
      if (!isValidUrl(this.retakeUrl)) {
        this.modelError = 'unAbleDomain'
      } else {
        this.modelError = ''
      }
      if (this.isExactMatchType && this.pageData.url !== this.retakeUrl) {
        this.modelError = 'unAbleDomain'
      }
    },
    onUrlBlur () {
      this.setUrl(this.retakeUrl)
      const nodeHost = this.pageData.linkHost
      const nodeTarget = this.pageData.linkPath
      if (!isMatchedURL(nodeHost, nodeTarget, this.retakeUrl)) {
        this.modelError = 'unAbleDomain'
      }
    },
    setCssSelector (value) {
      if (value) {
        this.excludeCheckChange(true)
      }
      this.retakeCss = value
    },
    excludeCheckChange (val) {
      this.excludeCheck = val
    },
    showHeatmapDialog (dialogType) {
      this.dialogType = dialogType
    },
    onDownloading (value) {
      this.isDownloading = value
    },
    getOffsetDistance () {
      this.offsetDistance = (window.innerWidth - 780) / 2
    },
    getSessionCacheKey () {
      const payload = {
        device: this.journeyOptions.device,
        start: this.journeyPeriod.start,
        end: this.journeyPeriod.end,
        sid: this.journeyOptions.sid,
        matchType: this.journeyOptions.matchType,
        exist: this.journeyOptions.exist,
        refer: this.journeyOptions.refer,
        aiRefererIds: this.journeyOptions.aiRefererIds,
        utm: this.journeyOptions.utm,
        survey: this.journeyOptions.survey,
        isCustomNode: this.journeyOptions.isCustomNode,
        subSid: this.journeyOptions.subSid,
        firstPathname: this.journeyOptions.firstPath,
        postSamplingRate: this.domain.postSamplingRate,
        isTotalSessNecessary: true
      }

      const { type, isFromFunnel = false, isAllSelected, excludedMembers = [], selectedMembers = [], memberCacheKey, sessionCacheKey } = this.tracking

      if (type === 'member') {
        payload.memberCacheKey = memberCacheKey
        payload.isAllMemberSelected = isAllSelected && isFromFunnel
        payload.excludedMembers = excludedMembers.map(item => item.id)
        payload.selectedMembers = isAllSelected ? [] : selectedMembers.map(item => item.id)
      } else {
        payload.isAllNonMemberSelected = isAllSelected
        payload.sessionCacheKey = sessionCacheKey
      }

      const key = getJourneyNodeKey(this.pageData, this.journeyOptions.isCustomNode)

      payload.nodeKey = key
      payload.treeId = this.pageData.id
      payload.pathStr = this.pageData.pathStr
      payload.isForStartNode = key === '-1'
      payload.isParent = this.domain.isParent

      return getNodeUsers(payload)
        .then(res => {
          this.sessionCacheKey = res.total_sessions_cache_key
        })
        .catch(e => {
          console.log(e)
        })
    }
  },
  destroyed () {
    this.isLoadedOnce = false
    this.clearData()
    window.removeEventListener('resize', this.getOffsetDistance)
  },
  mounted () {
    // this.getContainerStyle()
    this.getOffsetDistance()
    window.addEventListener('resize', this.getOffsetDistance)

    this.originHeight = this.$refs.heatmapsection.offsetHeight
  },
  async created () {
    // EventBus.$emit('onLoading', true)
    // console.log('created', this.pageData)
    this.device = this.journeyOptions.device || 'desktop'
    this.isDeviceAll = this.journeyOptions.device === null
    const startDate = new Date(this.journeyPeriod.start)
    const endDate = new Date(this.journeyPeriod.end)
    this.periodDays = differenceInDays(endDate, startDate) + 1

    this.eventType = this.device === 'desktop' ? 'click' : 'tap'
    this.currentPv = this.targetHeatmapPv
    this.reportView = this.report || 'journey'

    if (this.heatmapParams && this.heatmapParams.selectedSegment) {
      this.selectedSegment = {
        ...this.heatmapParams.selectedSegment
      }
    }
    if (this.heatmapParams && this.heatmapParams.eventSourceButtons) {
      this.eventSourceButtons = this.heatmapParams.eventSourceButtons
    }

    if (this.tracking) {
      await this.getSessionCacheKey()
    }

    await this.loadCaptureImage()
    if (this.heatmapParams && this.heatmapParams.event) {
      const event = this.heatmapParams.event
      if (event === 'path') {
        if (this.heatmapParams.core) {
          this.typeSource = 0
        } else {
          this.typeSource = 1
        }
      }
      this.eventType = this.heatmapParams.event

      if (['swipe', 'zoom'].includes(event)) {
        this.onChangeTypeSource(this.heatmapParams.event)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
$segmentHeight: 89;
$controlbarHeight: 61;

//:lang(ja) .heatmap__control-side > div .title { font-size: 12px !important; }
.ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  word-break: break-all;
}
.node-arrow {
  position: absolute;
  left: 100%;
  width: 200px;
  height: 25px;
  overflow: hidden;
  background-color: rgba(151,189,18,1);
  //background:linear-gradient(90deg, rgba(236,237,230,1) 0%, rgba(151,189,18,1) 50%, rgba(151,189,18,1) 100%);
  &:before {
    content: '';
    position: absolute;
    top: 50%;
    left: 100%;
    width: 0;
    height: 0;
    transform: translateY(-50%);
    border: 18px solid transparent;
    border-left: 20px solid rgba(151,189,18,1);
    border-right: 0;
  }
  .anima-arrow-1 {
    position: absolute;
    top: 50%;
    left: 0;
    width: 20px;
    height: 20px;
    transform: translateY(-50%) rotate(45deg);
    border: 1px solid #f4f4f1;
    opacity: .4;
    background-color: transparent;
    border-left-width: 0;
    border-bottom-width: 0;
  }
}
.basic__wrap {
  max-height: calc(100% - 120px);
  top: 50%;
  display: flex;
  flex-direction: column;
  position: relative;
  &.backward {
    & > svg {
      transform: rotate(180deg);
    }
  }
  .segment_area {
    background-color: #fff;
    border-radius: 10px 10px 0 0;
    .segment-header-wrapper {
      position: relative;
      padding: 20px;
      .close {
        position: absolute;
        right: 12px;
        top: 12px;
        cursor: pointer;
        .icon--close-btn {
          width: 32px;
          height: 32px;
        }
      }
      .segment-header-title {
        width: 90%;
        display: flex;
        align-items: center;
        column-gap: 5px;
        margin-bottom: 10px;
        .title {
          font-size: 18px;
          color: #2F2F2F;
          flex-grow: 1;
          max-width: 100%;
          line-height: 21px;
        }
        .link-btn {
          cursor: pointer;
          i {
            transform: rotate(90deg);
            vertical-align: bottom;
          }
        }
      }
      .segment-header-url {
        width: 90%;
        padding-left: 21px;
        font-size: 13px;
        color: #666;
        line-height: 18px;
        display: flex;
        align-items: center;
      }
    }

    &::after {
      position: absolute;
      z-index: 20;
      content: "";
      display: inline-block;
      vertical-align: baseline;
      width: 100%;
      height: 1px;
      background-color: #EBEBEB;
    }
  }
  .heatmap__control-bar-bottom {
    background-color: #fff;
    display: flex;
    position: relative;
    padding: 13px 20px;
    gap: 21px;

    .ui-tabs {
      &:not(:first-child) {
        position: relative;
          &:after {
          position: absolute;
          content: '';
          width: 1px;
          height: 20px;
          background-color: #D7D7D7;
          left: -11px;
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }

    .pv {
      position: absolute;
      right: 20px;
      bottom: 22px;
      color: #EC0047;
      font-size: 12px;
      font-style: normal;
      font-weight: 500;
      .num {
        color: #444;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
      }
    }

    .heatmap__control__play {
      height: 50px;
      display: flex;
      align-items: center;

      .checkbox_area {
        line-height: 50px;
        padding-left: 20px;

        .checkbox_wrap {
          position: relative;
          cursor: pointer;

          .icon {
            position: absolute;
            top: 50%;
            left: 0;
            transform: translateY(-50%);
          }

          &:nth-last-of-type(1) {
            margin-left: 18px;
          }
        }

        &::after {
          content: "";
          display: inline-block;
          vertical-align: middle;
          width: 1px;
          height: 16px;
          margin: 0 20px;
          background-color: #d1d1d1;
        }
      }

      .text {
        font-size: 14px;
        color: #2f2f2f;
        margin-left: 25px;
      }

      .select_area {
        display: flex;
        align-items: center;

        .label {
          margin-top: 3px;
          color: #767676;
          text-align: right;
          font-size: 13px;
          font-style: normal;
          font-weight: 500;
        }

        .select {
          margin: -10px 20px 0px 10px;
          & /deep/ .item--wrap {
            padding-left: 10px;
            border-radius: 5px;
            height: 32px;
            .item__list{
              z-index: 10;
              .item__list-wrap {
                .item__list-item {
                  padding-left: 10px;
                }
              }
            }
            .selected-item {
              .name {
                margin-top: -7px;
              }
            }
            .name {
              margin-top: 0;
            }
          }
        }
      }
      &::after {
        position: absolute;
        top: 50px;
        content: "";
        display: inline-block;
        vertical-align: baseline;
        width: 100%;
        height: 1px;
        background-color: #EBEBEB;
      }
    }
  }
  .scroll__wrap {
    min-height: 500px;
    position: relative;
    flex-grow: 1;
    background-color: #fff;
    margin: -1px 0;
    padding: 0 20px;
    &.only {
      padding: 0;
    }
    &:after {
      content: '';
      position: absolute;
      top: 100%;
      left: 0;
      width: 100%;
      height: 20px;
      background-color: #fff;
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
    }
    &.loading {
      overflow: hidden;
    }
    .scroll_content-loading {
      position: fixed;
      top: 50%;
      z-index: 11;
      left: 50%;
      .loading {
        position: static !important;
      }
    }
    .heatmap-option {
      position: relative;
      top: 0;
      //right: 50px;
      //z-index: 10;
      //height: 100%;

      .button {
        &:hover {
          .tooltip {
            opacity: 1;
          }
        }
        .tooltip {
          position: absolute;
          top: 50%;
          right: 48px;
          transform: translate(40px, -50%);
          opacity: 0;
          transition: transform 0.2s ease,
          opacity 0.2s ease;
          pointer-events: none;
          padding: 30px 20px 30px 10px;

          &::after {
            content: '';
            background-color: #fff;
            position: absolute;
            z-index: 2;
            transform: rotate(-135deg);
            width: 8px;
            height: 8px;
            box-shadow: -1px 1px 0 0 rgba(0, 0, 0, 0.16);
            top: calc(50% - 4.5px);
            right: 16px;
          }

          .tooltip-text {
            border-radius: 6px;
            white-space: nowrap;
            box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
            background-color: #ffffff;
            padding: 8px 10px 9px;
            color: #444444 !important;
            font-size: 13px;
            line-height: 1;
          }
        }
      }

      .view-mode {
        position: absolute;
        top: 25px;
        right: 25px;
        width: 20px;
        z-index: 1;

        a {
          width: 20px;
          height: 20px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
        }

        .fit-mode {
          position: relative;
          background: rgba(0, 0, 0, 0.3);
          border-radius: 3px;
          color: white;

          .mode {
            &.on {
              border-radius: 3px;
              background-color: #ec0147;
            }
          }
        }
        .icon {
          width: 16px;
          height: 16px;
          &.icon--download-heatmap {
            width: 20px;
            height: 20px;
          }
          &.icon--fit-horizontal {
            width: 20px;
            height: 20px;
          }
          &.icon--fit-vertical {
            width: 20px;
            height: 20px;
          }
        }
        .custom {
          border-radius: 3px;
          &.inquire {
            background-color: #FFB427;
            &.clicked {
              background-color: #FFD100;
            }
          }
          &.excel {
            background-color: rgb(255, 255, 255);
          }
          &.retake {
            background-color: #151515;
            &.show {
              background-color: #383838;
            }
          }
        }

        .heatmap, .excel, .retake, .inquire {
          margin: 10px 0;
        }
        .inquire {
          position: relative;
        }

        .loading__wrap {
          position: absolute;
          .small-loading {
            position: relative;
            border-radius: 8px;
            width: 16px;
            height: 16px;
            z-index: 10;
            .loading-circle {
              position: absolute;
              width: 16px;
              height: 16px;
              animation: loading 3s linear infinite;
              transition: opacity 0.3s ease;
              svg {
                height: 100%;
              }
              .loading-inner {
                stroke: {
                  dashoffset: 0;
                  dasharray: 300;
                  width: 24;
                  miterlimit: 10;
                  linecap: round;
                }
                animation: loading-circle 2s linear infinite;
                stroke: #fff;
                fill: transparent;
              }
            }
          }
        }

        .retake, .heatmap, .inquire, .excel{
          position: relative;
          & /deep/ .bubble {
            display: none;
            top: calc(50% - 47px);
            right: -9px;
            transform: translate(0, -50%);
            z-index: 999999;
          }
          & /deep/ .bubble .text {
            color: #666;
          }
          &:hover {
            .bubble {
              display: block
            }
          }
        }
        .toggle__wrap {
          position: relative;
        }
        .inquire-tooltip {
          display: flex;
          flex-direction: column;
          width: 280px;
          height: 280px;
          padding: 25px 25px 15px 25px;
          position: absolute;
          right: 0;
          z-index: 5;
          margin-top: 5px;
          border-radius: 6px;
          background: #2F2F2F;
          box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.30), 0px 0px 0px 1px rgba(255, 255, 255, 0.30);
          .inquire-tooltip-close {
            .icon {
              position: absolute;
              top: 8px;
              right: 8px;
              cursor: pointer;
            }
          }
          .title {
            color: #FFD100;
            font-size: 15px;
            font-style: normal;
            font-weight: 500;
            position: relative;
          }
          .description {
            line-height: 19px;
            color: #EBEBEB;
            font-size: 13px;
            font-style: normal;
            font-weight: 400;
            margin-top: 20px;

            &::after {
              content: "";
              display: inline-block;
              vertical-align: baseline;
              width: 100%;
              height: 1px;
              background-color: #555;
              margin: 20px 0;
            }
          }
          .input {
            height: 120px;
            padding: 10px;
            background-color: #505050;
            border: 1px solid #BBB;
            border-radius: 5px;
            resize: none;
            color: #fff;
            line-height: inherit;
          }
          .input::placeholder {
            color: #AAA;
          }
          // .input:focus {
          //   border-color: #289eef;
          // }
          .button--wrap {
            text-align: right;
            margin-top: 10px;
            button {
              font-size: 15px;
              font-style: normal;
              font-weight: 500;
              padding: 10px 15px;
              &.cancel {
                color: #888;
              }
              &.send {
                color: #FFD100;
              }
              &.disabled {
                opacity: 0.3;
                &:hover {
                  border-radius: 5px;
                  background: transparent;
                }
              }
              &:hover {
                border-radius: 5px;
                background: rgba(0, 0, 0, 0.30);
              }
            }
            .content__toast {
              display: inline-block;
              height: 32px;
              border-radius: 6px;
              box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16);
              background-color: rgba(0,0,0,0.85);
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              padding-left: 12px;
              padding-right: 45px;

              span {
                font-size: 13px;
                font-weight: 500;
                color: #57ab00;
                line-height: 32px;
              }

              i {
                position: absolute;
                top: 50%;
                right: 12px;
                transform: translateY(-50%);
              }
            }
          }
        }
        .retake-tooltip {
          z-index: 10;
          display: flex;
          flex-direction: column;
          width: 360px;
          height: 290px;
          padding: 25px 25px 20px 25px;
          position: absolute;
          right: 0;
          margin-top: 5px;
          border-radius: 6px;
          background: #2F2F2F;
          box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.30), 0px 0px 0px 1px rgba(255, 255, 255, 0.30);
          .retake-tooltip-close {
            position: absolute;
            top: 8px;
            right: 8px;
            cursor: pointer;
          }
          .title {
            color: #FFD100;
            font-size: 15px;
            font-style: normal;
            font-weight: 500;
            position: relative;
            .icon {
              position: absolute;
              top: -20px;
              right: -20px;
              cursor: pointer;
            }
          }
          .content {
            margin-top: 30px;
            &.disabled {
              opacity: 0.7
            }
          }
          .tooltip_wrap {
            padding-left: 6px;
            display: flex;
            align-items: center;
            .label {
              color: #c7c7c7;
              padding-right: 5px;
            }
          }
          & /deep/ .bubble {
            margin-left: -10px !important;
          }

          & /deep/ .bubble .text {
            text-align: left;
          }

          .selector-exclude-radios {
            padding: 14px 0 7px 6px;
            & /deep/ .ui_radio .text {
              color: #fff
            }
          }

          .loading {
            position: relative;
            margin: 10px auto 2px;
            padding: 7px;
            border-radius: 8px;
            width: 45px;
            height: 45px;
            z-index: 10;
            .loading-circle {
              position: absolute;
              width: 45px;
              height: 45px;
              animation: loading 3s linear infinite;
              transition: opacity 0.3s ease;
              svg {
                height: 100%;
              }
              .loading-inner {
                stroke: {
                  dashoffset: 0;
                  dasharray: 300;
                  width: 24;
                  miterlimit: 10;
                  linecap: round;
                }
                animation: loading-circle 2s linear infinite;
                stroke: #fff;
                fill: transparent;
              }
            }
          }

          .sub {
            color: #FFF;
            text-align: center;
            font-size: 15px;
            font-style: normal;
            font-weight: 500;
            padding: 55px 0 20px 0;
          }

          .description {
            color: #FFF;
            line-height: 19px;
            text-align: center;
            font-size: 13px;
            font-style: normal;
            font-weight: 500;
            padding: 20px 0;
          }

          .button--wrap {
            position: absolute;
            bottom: 15px;
            right: 20px;
            button {
              font-size: 15px;
              font-style: normal;
              font-weight: 500;
              padding: 10px 15px;

              &.cancel {
                color: #888;
              }
              &.send {
                color: #FFD100;
              }
              &.disabled {
                opacity: 0.3;
                &:hover {
                  border-radius: 5px;
                  background: transparent;
                }
              }
              &:hover {
                border-radius: 5px;
                background: rgba(0, 0, 0, 0.30);
              }
            }
          }

          .content__toast {
            display: inline-block;
            height: 32px;
            border-radius: 6px;
            box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16);
            background-color: rgba(0,0,0,0.85);
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            padding-left: 12px;
            padding-right: 45px;
            span {
              font-size: 13px;
              font-weight: 500;
              color: #57ab00;
              line-height: 32px;
            }
            i {
              position: absolute;
              top: 50%;
              right: 12px;
              transform: translateY(-50%);
            }
          }
        }
        .heatmap_colorrange {
          position: absolute;
          z-index: 1;
          top: 175px;
          right: 4px;
          width: 6px;
          border-radius: 2px;
          background: rgb(0, 0, 0);
          padding: 6px 3px;
          .hot,
          .cold {
            font-size: 10px;
            color: #fff;
            display: block;
            text-align: center;
            transform: translateX(-0.5px);
          }
          .color-variation {
            display: block;
            height: 120px;
            margin: 5px 0;
            border-radius: 5px;
          }
          &.regular .color-variation {
            background: linear-gradient(#fff, #ff0000, #fccb21, #00ff00, #1b85b9, #000);
          }
          &.scroll .color-variation {
            background: linear-gradient(#ff0000, #fccb21, #00ff00, #1b85b9, #000);
          }
        }
      }
    }

    .heatmap-outbox {
      // width: 740px;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      overflow-y: auto;
      overflow-x: hidden;
      margin: -1px 0;
      .view-area {
        position: absolute;
        top: 0;
        left: 20px;
        //right: 0;
        //bottom: 0;

        overflow: hidden;
        display: flex;
        justify-content: center;
        background-color: #1B1B1B;
        .heatmap-wrap {
          position: relative;
          z-index: 0;
          height: 100%;
          background-color: #1B1B1B;
          padding: 20px;
          &.only {
            padding: 0;
          }
          // margin: 20px auto 0;
          .img-layer {
            position: relative;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            margin: 0 auto;
            &::before {
              opacity: 0.7;
              position: absolute;
              inset: 0;
              background-color: #282b39;
              content: "";
            }
            .heatmap-area {
              height: 100%;
              transform-origin: top left;
            }
          }
        }
      }
      &.only_mode {
        position: static;
        top: 0;

        .path-option {
          display: none;
        }

        .view-area {
          position: static;
          top: 0;

          .heatmap-wrap {
            margin: 0;

            .img-layer {
              overflow: hidden;
            }
          }
        }
      }
    }
    .loading_indicator {
      position: absolute;
      z-index: 100;
      //width: 740px;
      //height: calc(100% - 111px);
      //top: 111px;
      //left: 20px;
      //right: 0;
      //bottom: 0;
      //inset:  0 20px 20px 20px;
      inset: 0 20px;
      background-color: #1B1B1D;

      .loading {
        position: absolute;
        width: 54px;
        height: 54px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }

      svg {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        z-index: 1;
        animation: loading 3s linear infinite;

        .loading-inner {
          stroke: {
            dashoffset: 0;
            dasharray: 300;
            width: 20;
            miterlimit: 10;
            linecap: round;
          }

          animation: loading-circle 2s linear infinite;
          stroke: #fff;
          fill: transparent;
        }
      }

      .loading_notice {
        position: absolute;
        left: 50%;
        bottom: -27px;
        transform: translateX(-50%);
        width: 300px;
        word-break: break-all;
        text-align: center;
        font-size: 13px;
        color: #ffffff;
      }

      @keyframes loading {
        0% {
          transform: rotate(0);
        }
        100% {
          transform: rotate(360deg);
        }
      }
      @keyframes loading-circle {
        0% {
          stroke-dashoffset: 0
        }
        100% {
          stroke-dashoffset: -600;
        }
      }
    }
  }
  .fake__wrap {
    display: none;
    div {
      position: relative;
      height: 20px;
      &.black {
        display: flex;
        justify-content: space-between;
        background-color: #1B1B1D;
        .white-block {
          width: 20px;
          background-color: #fff;
        }
      }
      &.white {
        border-radius: 0 0 10px 10px;
        background-color: #fff;
      }
    }
  }
  .heatmap__control-side {
    position: absolute;
    min-width: 85px;
    top: ($segmentHeight + $controlbarHeight) + px;
    right: 100%;
    padding-right: 8px;
    padding-bottom: 2px;
    background: linear-gradient(90deg, #F5F5F5 0%, #E5E5E5 11.46%, #E5E5E5 84.37%, #FFF 100%);
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    margin-right: -1px;
    & > div {
      margin: 0 16px;
      padding: 14px 0;
      border-top: 1px solid rgba(255, 255, 255, 0.16);
      border-bottom: 1px solid rgba(0, 0, 0, 0.08);
      .title {
        color: #666;
        font-size: 12px;
        padding-bottom: 10px;
      }
      .contents {
        display: flex;
        justify-content: sflex-start;
        column-gap: 5px;
        padding-right: 5px;
      }
      &:first-child { border-top-width: 0; }
      &:last-child { border-bottom-width: 0; }
    }
    &:before {
      content: '';
      position: absolute;
      right: -5px;
      top: -16px;
      border-bottom-right-radius: 16px;
      border: 6px solid #FBFBFB;
      width: 15px;
      height: 16px;
      border-top-width: 0;
      border-left-width: 0;
      z-index: -1;
    }
    &:after {
      content: '';
      position: absolute;
      right: -5px;
      bottom: -16px;
      border-top-right-radius: 16px;
      border: 6px solid #FBFBFB;
      width: 15px;
      height: 16px;
      border-bottom-width: 0;
      border-left-width: 0;
      z-index: -1;
    }
  }
  // display sequence number
  &:before {
    content: attr(seq);
    position: absolute;
    top: $segmentHeight + px;
    right: calc(100% + 10px);
    width: 48px;
    height: 48px;
    font-size: 26px;
    line-height: 1em;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 2px solid rgba(255, 255, 255, 0.80);
    border-radius: 8px;
    background-color: #333;
    color: #fff;
    font-weight: 500;
    transform: translateY(-50%);
  }
  // fake bottom padding
  // &:after {
  //   content: '';
  //   position: absolute;
  //   top: 100%;
  //   left: 0;
  //   width: 100%;
  //   height: 20px;
  //   background-color: #fff;
  //   border-bottom-left-radius: 10px;
  //   border-bottom-right-radius: 10px;
  // }
  @keyframes loading {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes loading-circle {
    0% {
      stroke-dashoffset: 0
    }
    100% {
      stroke-dashoffset: -600;
    }
  }
}

</style>
